import {Action} from '../typescript/actionTypes';
import {ActionTypes} from '../types/actionTypes';
import {InitialState} from './initialState';
import {StoreTsCodes} from '../typescript/storeTypes';

export default function (state: StoreTsCodes = InitialState.mostRecentTsCodes, action: Action): StoreTsCodes {
    switch (action.type) {
        case ActionTypes.MOST_RECENT_TSCODES_SUCCEEDED: {
            return (action.payload as StoreTsCodes);
        }
        default: {
            return state;
        }
    }
}
